import { DropdownOption } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardJudgeCapacityOptions: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<DropdownOption<number>[]> = (fetchContext, awardId, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/awards/${awardId}/judge-capacity-options`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<DropdownOption<number>[]>(fetchContext.errorStore, response, 'get award judge capacity options'));
